<div class="mat-snack-bar-container custom-snackbar">
    <div class="snack-bar-text-container">
        <img class="mr-1" src="assets/svg-icons/warning_amber.svg" alt="">
        <span>{{ 'snackbar.desc.1' | translate }}<u>support&#64;hvb.services</u>{{ 'snackbar.desc.2' | translate }}</span>
    </div>
    <button (click)="refreshPage()">
        <span>{{ 'snackbar.refresh' | translate }}</span>
    </button>
</div>

